import { RouterProvider } from 'react-router-dom';
import './assets/scss/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import router from './router';
import QueryProvider from './provider/QueryProvider';
import { AuthProvider, useAuthContext } from './provider/AuthProvider';
import { SSO_CALLBACK, SSO_LOGIN, STATUS_CHECK } from './router/routes';
import { ToastContainer } from 'react-toastify';
import AtsSyncToastListener from './core/protected/Integrations/Ats/AtsSyncToastListener';

// SSO callback and its failure fallback are auth-transition screens: the IdP always
// redirects to /sso/callback regardless of whether a (possibly stale) token still
// exists. Since only the public router knows these routes, a lingering token would
// otherwise mount the protected router and 404. Always serve them from the public
// router; a successful callback hard-navigates to "/", re-mounting the correct router.
// STATUS_CHECK belongs here for the same reason: it resolves a signed account-action
// link entirely server-side (token/sig query params), independent of whatever session
// already happens to be in the browser, so a stale token must not route it into the
// protected router (which has no matching route at all).
const AUTH_TRANSITION_PATHS = [SSO_CALLBACK, SSO_LOGIN, STATUS_CHECK];

function App() {
  window.addEventListener('vite:preloadError', () => {
    window.location.reload();
  });
  return (
    <QueryProvider>
      <AuthProvider>
        <Landing />
      </AuthProvider>
      <ToastContainer position="top-right" autoClose={5000} />
    </QueryProvider>
  );
}

function Landing() {
  const { isAuthenticated } = useAuthContext();
  // const isAuthenticated = true;
  // Auth-transition paths must resolve even when a stale token is present, so they
  // always use the public router. Read at mount only — entering /sso/callback is
  // always a full page load (IdP redirect), so this never needs to be reactive.
  const isAuthTransition = AUTH_TRANSITION_PATHS.includes(window.location.pathname);
  return (
    <>
      {isAuthenticated && !isAuthTransition ? (
        <>
          <AtsSyncToastListener />
          <RouterProvider router={router.protectedRouter} />
        </>
      ) : (
        <RouterProvider router={router.publicRouter} />
      )}
    </>
  );
}

export default App;
